module.exports = __webpack_public_path__ + "img/zuo.8d9215b3.jpg";